/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_Category_Ui_GraphicInputs */

const en_gallery_category_ui_graphic = /** @type {(inputs: Gallery_Category_Ui_GraphicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UI & Graphic`)
};

const es_gallery_category_ui_graphic = /** @type {(inputs: Gallery_Category_Ui_GraphicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UI y grafico`)
};

/**
* | output |
* | --- |
* | "UI & Graphic" |
*
* @param {Gallery_Category_Ui_GraphicInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const gallery_category_ui_graphic = /** @type {((inputs?: Gallery_Category_Ui_GraphicInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_Category_Ui_GraphicInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_category_ui_graphic(inputs)
	return es_gallery_category_ui_graphic(inputs)
});